"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_1 = require("@apollo/client");
const query = (0, client_1.gql) `
  query optimizedOrders($query: OrderQueryInput, $pagination: PaginationInput) {
    orders(query: $query, pagination: $pagination) {
      _id
      eventName
      printed
      createdAt
      state
      channel
      type
      tax
      refundedAmount
      user {
        email
        firstName
        lastName
      }
      event {
        name
        subtitle
        isMultipleDays
        posterImageUrl {
          original
          medium
          small
        }
        schedule {
          startsAt
          endsAt
        }
        venue {
          name
          address {
            timezone
          }
        }
      }
      season {
        venue {
          address {
            timezone
          }
        }
      }
      fees {
        amount
      }
      payments {
        amount
      }
      orderIntegrationResponse {
        success
        createdAt
      }
      tickets {
        state
        values
        price
        paymentId
        scan {
          scanned
          startsAt
        }
      }
      upgrades {
        state
        price
        paymentId
        scan {
          scanned
          startsAt
        }
      }
    }
  }
`;
exports.default = query;
//# sourceMappingURL=ordersTableOptimized.query.js.map